// extracted by mini-css-extract-plugin
export default {"otpContainer":"VerifyOTP_otpContainer__g9SxX","otpInput":"VerifyOTP_otpInput__VeAIc","otpError":"VerifyOTP_otpError__T9FS0"};